module.exports = __webpack_public_path__ + "static/media/oncology-image1.474af325.png";